/**
 * @generated SignedSource<<530fc06f288abd0a8cc6caf46eb1c0df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapContextProvider_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "3df7135c40c6da81781004b02a093958";

module.exports = node;
